module.exports = __webpack_public_path__ + "img/ico_sbdt.370ec88c.png";